export default "__VITE_ASSET__bd0fd9d7__"